import {
  INIT_TWO_FACTOR_ENABLED,
  INITIATE_2FA_SETUP_REQUEST,
  INITIATE_2FA_SETUP_SUCCESS,
  INITIATE_2FA_SETUP_FAILURE,
  INITIATE_2FA_SETUP,
  VERIFY_2FA_SETUP_REQUEST,
  VERIFY_2FA_SETUP_SUCCESS,
  VERIFY_2FA_SETUP_FAILURE,
  VERIFY_2FA_SETUP,
  DISABLE_2FA_REQUEST,
  DISABLE_2FA_SUCCESS,
  DISABLE_2FA_FAILURE,
  DISABLE_2FA,
} from '../../actions/two_factor_actions'

export default function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_TWO_FACTOR_ENABLED:
      return {
        ...state,
        twoFactorEnabled: action.isEnabled
      }
    case INITIATE_2FA_SETUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      }

    case INITIATE_2FA_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null
      }

    case INITIATE_2FA_SETUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.response?.data?.errors || action.error.message,
        success: null
      }

    case INITIATE_2FA_SETUP:
      return {
        ...state,
        otpSecret: action.data.otp_secret,
        qrCodeUrl: action.data.qr_code_data
      }

    case VERIFY_2FA_SETUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      }
    
    case VERIFY_2FA_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.data.message
      }

    case VERIFY_2FA_SETUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.response?.data?.message || action.error.message,
        success: null
      }

    case VERIFY_2FA_SETUP:
      return {
        ...state,
        otpRequired: true,
        twoFactorEnabled: true,
        backupCodes: action.data.backup_codes
      }

    case DISABLE_2FA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      }
    
    case DISABLE_2FA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.data.message,
        error: null
      }

    case DISABLE_2FA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.response?.data?.errors || action.error.message,
        success: null
      }

    case DISABLE_2FA:
      return {
        ...state,
        otpRequired: false,
        otpSecret: null,
        qrCodeUrl: null,
        twoFactorEnabled: false
      }

    default:
      return state
  }
}